export default __webpack_public_path__ + "static/media/add.eddc4c6e.svg";